/* KILO / Between 2 Racks episode. Native JS, no tracking, no player loaded until clicked. */
(() => {
  'use strict';
  const root = document.querySelector('.b2r-page');
  if (!root) return;
  const player = root.querySelector('[data-b2r-player]');
  const notes = root.querySelector('[data-b2r-notes]');
  const button = () => player?.querySelector('.b2r-video-trigger');
  const frame = () => player?.querySelector('iframe');
  const seconds = stamp => stamp.split(':').reduce((sum, val) => sum * 60 + parseInt(val, 10), 0);
  const startFromUrl = () => Math.max(0, parseInt(new URLSearchParams(location.search).get('t') || '0', 10) || 0);
  const load = (trigger, at = 0) => {
    const id = trigger.dataset.youtubeId;
    if (!/^[a-zA-Z0-9_-]{11}$/.test(id || '')) return;
    const el = document.createElement('iframe');
    el.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&enablejsapi=1&start=${Math.max(0, at)}`;
    el.title = trigger.getAttribute('aria-label') || 'Between 2 Racks video';
    el.allow = 'autoplay; encrypted-media; picture-in-picture';
    el.allowFullscreen = true;
    trigger.replaceWith(el);
  };
  const seek = time => {
    const activeFrame = frame();
    const trigger = button();
    if (activeFrame) {
      activeFrame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'seekTo',args:[time,true]}), 'https://www.youtube-nocookie.com');
      activeFrame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'playVideo',args:[]}), 'https://www.youtube-nocookie.com');
    } else if (trigger) load(trigger, time);
    player?.scrollIntoView({behavior:'smooth',block:'center'});
  };
  root.addEventListener('click', event => {
    const trigger = event.target.closest('.b2r-video-trigger');
    if (trigger) load(trigger, startFromUrl());
    const ch = event.target.closest('[data-b2r-seek]');
    if (ch) seek(Number(ch.dataset.b2rSeek));
  });
  /* Only return to an internal /blogs/podcast path. Preserve search, sort and pagination. */
  let saved='';
  try { saved=sessionStorage.getItem('b2rList') || ''; }catch (_) {}
  if(!saved && document.referrer) {
    try {const ref=new URL(document.referrer);if(ref.origin===location.origin && ref.pathname==='/blogs/podcast')saved=ref.pathname+ref.search;}catch (_) {}
  }
  if(saved) {
    try {const route=new URL(saved,location.origin);if(route.origin===location.origin && route.pathname==='/blogs/podcast')root.querySelectorAll('[data-b2r-back]').forEach(link=>link.href=route.pathname+route.search);}catch (_) {}
  }
})();
